module.exports = __webpack_public_path__ + "static/media/account-balance.2bdcc6cf.svg";